import template from "./pProcessNotes.html";
import { Notes as NotesComponent } from '../Notes/Notes';
import { ProcessNotes } from './ProcessNotes';
import angular from "angular";
import moment from "moment";

export function pProcessNotesDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pProcessNotesController,
    controllerAs: 'pProcessNotes',
    bindToController: true
  };

  return directive;
}

class pProcessNotesController {
  constructor($routeParams, $location, $window, Work, $interval, $q, $scope, $translate, Auth, Notes, ConnectionQuality) {
    'ngInject';

    this.$window = $window;
    this.$location = $location;
    this.$q = $q;
    this.$translate = $translate;

    this.Work = Work;
    this.Auth = Auth;

    this.NotesComponent = NotesComponent;
    this.ProcessNotes = ProcessNotes;
    this.notesProps = {
      text: '',
      automation: [],
      saveNote: (note, automation) => this.saveNote(note, automation),
      automationTechnologies: []
    };

    this.clientId = $routeParams.clientId;
    this.processId = $routeParams.processId;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;

    if (!this.processId) {
      this.notesProps.clientNotes = true;
      this.notesProps.clientNotesHeader = this.$translate.instant('NOTES.CLIENT_NOTE');
    }
      
    this.state = "loading";

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        this.interactiveNotesFeatureFlag = this.user.preferences.featureFlags.some(ff => ff === "InteractiveNotes");

        if (!this.interactiveNotesFeatureFlag)
          $location.path($location.url().slice(0, $location.url().length - 6));

        this.Work.postHearbeat({processId: this.processId, clientId: this.clientId}).then(
          () => {
            this.postHeartbeatInterval = $interval(() => this.Work.postHearbeat({processId: this.processId, clientId: this.clientId}), 30 * 1000);

            setTimeout(() => {
              if (this.processId)
                $window.opener.pProcessRun.timeoutError();
              else
                $window.opener.pClientExplorer.timeoutError();
              $window.close();
            }, 60 * 60 * 1000);

            const noteTimeout = $interval(() => {
              this.notes = Notes.getNotes();
            }, 150);

            $scope.$on("$destroy", () => { $interval.cancel(noteTimeout); $interval.cancel(this.postHeartbeatInterval); });

            const requests = [
              this.Work.getNoteLatestVersion({clientId: this.clientId, processId: this.processId}),
              this.Work.getNoteHistory({clientId: this.clientId, processId: this.processId}),
            ];

            if (this.processId) {
              requests.push(this.Work.getAutomationTechnologyForCountry());
              requests.push(this.Work.getClientsAutomationTechnology({clientId: this.clientId, processId: this.processId}));
            }

            $q.all(requests).then(
              (success) => {
                this.state = 'loaded';
                const notesProps = angular.copy(this.notesProps);

                if (success[0].data)
                  notesProps.text = success[0].data.content;

                if (success[1].data)
                  notesProps.noteHistory = success[1].data
                    .map(history => ({
                      ...history,
                      createdAt: moment(history.createdAt).format("YYYY-MM-DD HH:mm:ss")
                    }));

                if (!$window.opener)
                  sessionStorage.setItem('notes-info', JSON.stringify({
                    client: $routeParams.name.slice(2),
                    processGroup: $routeParams.processGroupName.slice(2),
                    process: $routeParams.processName
                  }));

                notesProps.automationTechnologies = success[2] && success[2].data
                  ? Object
                    .entries(success[2].data.automations)
                    .map(([id, automationName]) => ({id, automationName}))
                    .sort((technologyA, technologyB) => technologyA.automationName.localeCompare(technologyB.automationName))
                  : [];

                if (success[3] && success[3].data)
                  notesProps.automation = success[3].data.automationIds;

                this.notesProps = notesProps;
              }, (error) => {
                this.Notes.postNote({ type: "error", description: "ERROR_LOADING_DATA", error: error });
                this.state = 'error';
              }
            );
          }
          , () => {
            if (this.processId)
              $window.opener.pProcessRun.notesPageError();
            else
              $window.opener.pClientExplorer.notesPageError();
            $window.close();
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  saveNote(note, automation) {
    this.state = 'loading';
    const data = {content: note, processId: this.processId, clientId: this.clientId, automation};
    const savePromises = [this.Work.saveNote(data)];
    if (JSON.stringify(automation.sort()) !== JSON.stringify(this.notesProps.automation.sort()))
      savePromises.push(this.Work.saveClientsAutomationTechnologies({processId: this.processId, clientId: this.clientId, automationIds: automation}));

    this.$q.all(savePromises).then(
      () => {
        if (this.processId)
          this.$window.opener.pProcessRun.noteSaved();
        else
          this.$window.opener.pClientExplorer.noteSaved();
        this.$window.close();
      }, (error) => {
        this.Notes.postNote({ type: "error", description: "WORK.ERROR", error: error });
        this.state = 'error';
      }
    );
  }

  close() {
    this.Work.clearHeartbeat({processId: this.processId, clientId: this.clientId})
      .then(() => {
        if (this.$window.opener) {
          if (this.processId)
            this.$window.opener.pProcessRun.notesPageClosed();
          else
            this.$window.opener.pClientExplorer.notesPageClosed();
          this.$window.close();
        } else
          this.$location.path('/');
      });
  }
}
